import React from 'react';
import classNames from 'classnames';

import { useWindowStore } from '../../stores';

const ModalCloseBtn = ( { closeFunc } ) => {
  const isMobile = useWindowStore((state) => state.isMobile);
  return (
    <button
      type="button"
      className={classNames( {
        modal__closeBar: isMobile,
        modal__closeBtn: !isMobile,
      } )}
      onClick={closeFunc}
      data-testid="modal-close-button"
    >
      <span className="sr-only">Close</span>

      {isMobile && (
        <div className="modal__closeBarX" />
      )}
    </button>
  );
};

export default ModalCloseBtn;
